import React from "react";
import {
  Bot,
  LineChart as LineChartUp,
  Cpu,
  ScrollText,
  Settings2,
  Shield,
} from "lucide-react";
import "./Features.css";

function Feature() {
  return (
    <section className="py-20" id="features" z-index="1000">
      <div className="container mx-auto px-6">
        {/* Section Title */}
        <h2 className="text-4xl font-bold text-center mb-12">
          <span className="bg-gradient-to-r from-emerald-600 to-teal-500 bg-clip-text text-transparent">
            Powerful Features for Smart Trading
          </span>
        </h2>

        {/* Feature Cards */}
        <div className="grid md:grid-cols-3 gap-8">
          <FeatureCard
            icon={<Bot className="h-12 w-12 text-emerald-600" />}
            title="AI-Powered Analysis"
            description="Advanced algorithms analyze market patterns and predict potential trading opportunities."
          />
          <FeatureCard
            icon={<LineChartUp className="h-12 w-12 text-emerald-600" />}
            title="Real-time Tracking"
            description="Monitor your strategies' performance with live updates and detailed analytics."
          />
          <FeatureCard
            icon={<Shield className="h-12 w-12 text-emerald-600" />}
            title="Risk Management"
            description="Built-in safety features to protect your investments and limit potential losses."
          />
          <FeatureCard
            icon={<Settings2 className="h-12 w-12 text-emerald-600" />}
            title="Custom Strategies"
            description="Create and customize trading strategies using our intuitive visual builder."
          />
          <FeatureCard
            icon={<ScrollText className="h-12 w-12 text-emerald-600" />}
            title="Detailed Reports"
            description="Comprehensive reporting and analytics to track your trading performance."
          />
          <FeatureCard
            icon={<Cpu className="h-12 w-12 text-emerald-600" />}
            title="Automated Execution"
            description="Set your strategies to execute trades automatically based on your rules."
          />
        </div>
      </div>
    </section>
  );
}

// FeatureCard Component
function FeatureCard({ icon, title, description }) {
  return (
    <div className="bg-white rounded-xl shadow-lg hover:shadow-2xl transition-shadow duration-300 p-8 flex flex-col items-center text-center border border-gray-200">
      <div className="bg-emerald-100 rounded-full p-5 mb-6">{icon}</div>
      <h3 className="text-lg font-bold text-gray-800 mb-3">{title}</h3>
      <p className="text-gray-600 leading-relaxed">{description}</p>
    </div>
  );
}

export default Feature;
